import BTCLogo from '../assets/btc.svg';
import ETHLogo from '../assets/eth.svg';
import SushiLogo from '../assets/sushi.png';
import mainnet from './mainnetConfig';
import regtest from './regtestConfig';
import testnet from './testnetConfig';

const network = process.env.REACT_APP_NETWORK;

interface NetworkSpecificConfig {
  bitcoin: {
    api: string;
    batchApi: string;
    network: string;
    value: number;
    mineBlocks: boolean;
    explorer: string;
    altApi?: string;
  };
  basename: string;
  oracle: {
    url: string;
  };
  tower: {
    url: string;
  };
  broker: {
    url: string;
  };
  pay: {
    url: string;
  };
  mailchimp: {
    url: string;
  };
  fee: string;
}

const configs: { [key: string]: NetworkSpecificConfig } = {
  regtest,
  testnet,
  mainnet,
};

export default {
  ...configs[network || 'mainnet'],
  assets: {
    btcusd: {
      name: 'Bitcoin',
      asset: 'btc',
      currency: 'usd',
      logo: BTCLogo,
    },
    ethusd: {
      name: 'Ether',
      asset: 'eth',
      currency: 'usd',
      logo: ETHLogo,
    },
    sushiusd: {
      name: 'Sushi',
      asset: 'sushi',
      currency: 'usd',
      logo: SushiLogo,
    },
  },
};
